import React from "react";

interface SelectableCountButtonProps {
  label: string;
  checked: boolean;
  onChange: (value: boolean) => void;
  onButtonClick: () => void;
  isHasFullPermission:boolean;
}

const SelectableCountButton: React.FC<SelectableCountButtonProps> = ({
  label,
  checked,
  onChange,
  onButtonClick,
  isHasFullPermission
}) => {
  return (
    <span
      className={`
        inline-flex items-center gap-2
        px-3 py-1.5 rounded-lg text-sm font-medium
        border transition-all duration-200
        ${
          checked
            ? isHasFullPermission ?"border-green-400 text-green-500 bg-green-100": "border-blue-400 text-blue-500 bg-blue-50"
            : "border-gray-200 text-gray-700 bg-white"
        }
      `}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={() => onChange(!checked)}
        className="accent-greenBg"
      />

      <button
        type="button"
        onClick={() => {
          if (checked) onButtonClick(); 
        }}
        className="disabled:opacity-50"
        disabled={!checked}
      >
        {label}
      </button>
    </span>
  );
};

export default SelectableCountButton;
